export const colors = {
	primary: '#9254de', // 'purple-5'
	libraNight: '#06061f',
	libraStar: '#f5b21e',
	meal: '#36cfc9', // 'cyan-5'
	activity: '#ff4d4f', // 'red-5'
	practice: '#73d13d', // 'green-5'
	background: '#f5f5f5',
}
